module.exports = __webpack_public_path__ + "img/error-404-img.9a76bf6.svg";